module.exports = __webpack_public_path__ + "img/bell.e97c3712.gif";